var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showLabel && false)?_c('div',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.description))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }